<template>
  <el-container class="layout-container">
    <!-- 侧边栏 -->
    <el-aside :width="collapsed ? '64px' : '220px'" class="sidebar">
      <div class="logo">
        <i class="el-icon-s-home logo-icon"></i>
        <span v-if="!collapsed" class="logo-text">众惠家政管理</span>
      </div>
      <el-menu
        :default-active="$route.path"
        :collapse="collapsed"
        background-color="#001529"
        text-color="#ffffffa6"
        active-text-color="#ffffff"
        router
        unique-opened
      >
        <el-menu-item v-for="item in menuItems" :key="item.path" :index="item.path">
          <i :class="item.icon"></i>
          <span slot="title">{{ item.title }}</span>
        </el-menu-item>
      </el-menu>
    </el-aside>

    <el-container>
      <!-- 顶部导航 -->
      <el-header class="header">
        <div class="header-left">
          <i
            :class="collapsed ? 'el-icon-s-unfold' : 'el-icon-s-fold'"
            class="collapse-btn"
            @click="collapsed = !collapsed"
          ></i>
          <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>{{ currentTitle }}</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="header-right">
          <el-dropdown @command="handleCommand">
            <span class="user-info">
              <el-avatar :size="32" icon="el-icon-user-solid" />
              <span class="username">{{ adminInfo.realName || adminInfo.username }}</span>
              <i class="el-icon-arrow-down"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="logout">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </el-header>

      <!-- 主内容 -->
      <el-main class="main-content">
        <router-view />
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Layout',
  data() {
    return {
      collapsed: false,
      menuItems: [
        { path: '/dashboard', title: '工作台', icon: 'el-icon-odometer' },
        { path: '/service', title: '服务管理', icon: 'el-icon-s-shop' },
        { path: '/order', title: '订单管理', icon: 'el-icon-s-order' },
        { path: '/member', title: '会员卡管理', icon: 'el-icon-bank-card' },
        { path: '/coupon', title: '优惠券管理', icon: 'el-icon-present' },
        { path: '/timeslot', title: '时段配置', icon: 'el-icon-time' },
        { path: '/user', title: '用户管理', icon: 'el-icon-user' },
        { path: '/staff', title: '员工管理', icon: 'el-icon-s-custom' },
        { path: '/caregiver-reg', title: '阿姨登记', icon: 'el-icon-edit-outline' },
        { path: '/employer-demand', title: '雇主需求', icon: 'el-icon-document' },
        { path: '/stat', title: '数据统计', icon: 'el-icon-data-analysis' },
        { path: '/system', title: '系统设置', icon: 'el-icon-setting' },
        { path: '/grid-menu', title: '宫格菜单', icon: 'el-icon-menu' },
        { path: '/faq', title: '常见问题', icon: 'el-icon-question' }
      ]
    }
  },
  computed: {
    ...mapGetters(['adminInfo']),
    currentTitle() {
      const item = this.menuItems.find(m => this.$route.path.startsWith(m.path))
      return item ? item.title : ''
    }
  },
  methods: {
    handleCommand(cmd) {
      if (cmd === 'logout') {
        this.$confirm('确认退出登录？', '提示', { type: 'warning' }).then(() => {
          this.$store.dispatch('logout')
          this.$router.push('/login')
        })
      }
    }
  }
}
</script>

<style scoped>
.layout-container { height: 100vh; }
.sidebar { background: #001529; transition: width 0.3s; overflow: hidden; }
.logo {
  height: 60px; display: flex; align-items: center; justify-content: center;
  padding: 0 16px; border-bottom: 1px solid #ffffff1a;
}
.logo-icon { font-size: 24px; color: #fff; margin-right: 8px; flex-shrink: 0; }
.logo-text { color: #fff; font-size: 16px; font-weight: 600; white-space: nowrap; }
.el-menu { border-right: none; }
.header {
  background: #fff; display: flex; align-items: center;
  justify-content: space-between; padding: 0 20px;
  box-shadow: 0 1px 4px rgba(0,21,41,.08);
}
.header-left { display: flex; align-items: center; gap: 16px; }
.collapse-btn { font-size: 20px; cursor: pointer; color: #666; }
.collapse-btn:hover { color: #409eff; }
.header-right { display: flex; align-items: center; }
.user-info { display: flex; align-items: center; gap: 8px; cursor: pointer; }
.username { font-size: 14px; color: #333; }
.main-content { background: #f0f2f5; padding: 20px; overflow-y: auto; }
</style>
